module.exports = __webpack_public_path__ + "static/media/app_screens_3.de2cd087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_screens_3.png
// module id = 368
// module chunks = 0